import { render, staticRenderFns } from "./CustomerMoneyDetail.vue?vue&type=template&id=4464d6fa&scoped=true&"
import script from "./CustomerMoneyDetail.vue?vue&type=script&lang=js&"
export * from "./CustomerMoneyDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4464d6fa",
  null
  
)

export default component.exports